import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JoiPage } from 'globals/store/permissions.data';
import { PageGroup } from 'src/app/store/permissions.era';
import { sleepForMS } from 'src/app/helpers/helpers';
import { Wrapper } from '../wrapper.component';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'mobile-menu',
    template: `
<div class="mobile" *ngIf="!!pageGroup">
  <div class="top">
    <div class="page-holder" (click)="openMenu()">
      <icon [icon]="pageGroup.icon"></icon>
      <div class="label">{{ pageGroup.label }}</div>
    </div>
    <ng-content select=".top-right"></ng-content>
  </div>
  <joi-nav-wrapper
    class="selections"
    *ngIf="selections.length > 1"
    [menuItems]="selections"
    [selectedId]="selected" 
    (selectItem)="changePage($event)"
  >
    <div class="edit-visible desktop" *ngIf="!!totalItems" (click)="editVisible.emit()">
      <label>EDIT VISIBLE</label>
      <div class="count">{{ visibleItems }} / {{ totalItems }}</div>
    </div>
    <ng-content select=".lower-right"></ng-content>
  </joi-nav-wrapper>
  <div style="flex:1;"></div>
</div>
<ng-content select=".mobile-menu-bottom"></ng-content>

`,
    styleUrls: ['./mobile-menu.scss', './edit-visible.scss'],
    standalone: true,
    imports: [JoiNavWrapper, CommonModule, IconComponent]
})
export class MobileMenuComponent extends Wrapper<MobileMenuComponent> implements OnInit {
  @Input() visibleItems: number
  @Input() totalItems: number
  @Output() editVisible: EventEmitter<void> = new EventEmitter()

  pageGroup: PageGroup
  page: JoiPage
  selections: string[] = []
  selected: string

  ngOnInit() {
    this.subCallback(this.store.select('permissions', 'openPage'), page => {
      this.page = page
      // console.log({ page })
      if (!page) return
      this.selected = page.label.toUpperCase()
    })
    this.subCallback(this.store.select('permissions', 'openGroup'), openGroup => {
      this.pageGroup = openGroup
      if (!openGroup) return
      try {
        this.selections = !openGroup.mobileHandles ? openGroup.pages.map(p => p.label.toUpperCase()) : 
          openGroup.mobileHandles
            .map(handle => openGroup.pages.find(p => p.handle === handle))
            .filter(p => p) // no guarantee here
            .map(p => p.label.toUpperCase())
      } catch {
        console.log("Mapping Error", { openGroup })
      }
    })
  }
  
  async changePage(selection: string) {
    if (selection === this.selected) return
    const page = this.pageGroup.pages.find(p => p.label.toUpperCase() === selection)

    console.log("Should be changing page", { page, selection, selected: this.selected })

    await sleepForMS(0)
    this.router.navigate(['/' + page.url, this.eventService.eventId])

  }

  openMenu() {
    this.uiService.openMobileMenu()
  }

}

